export class BurialSocietyDocumentsConfiguration {
  url: string;
}
